import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {trigger, state, style, animate, transition} from '@angular/animations';
import {FlashMessage} from './flash-message';
import {FlashMessagesService} from './flash-messages.service';
import {FlashMessageInterface} from './flash-message.interface';

@Component({
    selector: 'flash-messages',
    styleUrls: ['./flash-messages.component.scss'],
    templateUrl: './flash-messages.component.html',
    animations: [
        trigger('flyInOut', [
            state('in', style({transform: 'translateX(0)'})),
            transition('void => *', [
                style({transform: 'translateX(100%)'}),
                animate(300)
            ]),
            transition('* => void', [
                animate(300, style({transform: 'translateX(100%)'}))
            ])
        ])
    ]
})
export class FlashMessagesComponent implements OnInit {
    private config = {
        timeout: 7000,
        closeOnClick: true,
        showCloseBtn: true,
        cssClass: '',
        text: "default message",
        type: 'success'
    };

    text: string;
    messages: FlashMessageInterface[] = [];
    classes: string = '';
    _grayOut: boolean = false;

    constructor(private _flashMessagesService: FlashMessagesService, private _cdRef: ChangeDetectorRef) {
        this._flashMessagesService.show = this.show.bind(this);
        this._flashMessagesService.grayOut = this.grayOut.bind(this);
    }

    ngOnInit() {
    }

    show(text?: string, options = {}): void {
        for (let attrName  in options) {
            (<any>this.config)[attrName] = (<any>options)[attrName];
        }

        let message = new FlashMessage(text, this.config.type, this.config.cssClass, this.config.closeOnClick,
            this.config.showCloseBtn);

        message.timer = window.setTimeout(() => {
            this._remove(message);
            this._cdRef.detectChanges();
        }, this.config.timeout);

        this.messages.push(message);
        this._cdRef.detectChanges();
    }

    close(message: FlashMessage): void {
        clearTimeout(message.timer);
        this._remove(message);
        this._cdRef.detectChanges();
    }

    alertClicked(message: FlashMessage): void {
        if (message.closeOnClick) {
            this.close(message);
        }
    }

    grayOut(value = false) {
        this._grayOut = value;
    }

    private _remove(message: FlashMessageInterface) {
        this.messages = this.messages.filter((msg) => msg.id !== message.id);
    }
}
